export default "__VITE_ASSET__DSLWvlRh__"